module.exports = "/_next/static/images/fffa9dcea92339d8035eb825365d1366-nobureaucracy@0.75x.png.webp";